define("calendar/components/calendar/scheduled-stories", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "moment", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _object, _computed, _service, _utils, _component2, _tracking, _moment, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"moment",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class={{concat-classes
      "cCA--stories"
      (if this.showFutureTrendsOnCalendar "cCA--stories__future-trends")
      (if @showAdditionalBanner "is--offset")
    }}
    {{did-insert this.fetchStoryCounts}}
    {{did-update this.fetchStoryCounts @timelineStories @targetDate}}
    {{on "click" this.viewStoriesCalendar}}
  >
    {{#if this.dailyStoriesCounts.length}}
      {{#each this.dailyStoriesCounts as |dayStoryCount|}}
        {{#if (are-equal dayStoryCount 0)}}
          <div class="cCA--stories__item u--text--white">
            {{t "stories.scheduled_count.no_stories"}}
          </div>
        {{else if (are-equal dayStoryCount 1)}}
          <div class="cCA--stories__item">
            {{t "stories.scheduled_count.one_story"}}
          </div>
        {{else}}
          <div class="cCA--stories__item">
            {{t "stories.scheduled_count.number_stories" storyCount=dayStoryCount}}
          </div>
        {{/if}}
      {{/each}}
    {{else}}
      <div class="cCA--stories__item">
        {{t "stories.scheduled_count.none_scheduled"}}
      </div>
    {{/if}}
    <span class="cCA--stories__hint">
      {{t "stories.scheduled_count.click_stories_tab"}}
    </span>
  </div>
  */
  {
    "id": "WCpwismf",
    "block": "[[[11,0],[16,0,[28,[37,0],[\"cCA--stories\",[52,[30,0,[\"showFutureTrendsOnCalendar\"]],\"cCA--stories__future-trends\"],[52,[30,1],\"is--offset\"]],null]],[4,[38,2],[[30,0,[\"fetchStoryCounts\"]]],null],[4,[38,3],[[30,0,[\"fetchStoryCounts\"]],[30,2],[30,3]],null],[4,[38,4],[\"click\",[30,0,[\"viewStoriesCalendar\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"dailyStoriesCounts\",\"length\"]],[[[42,[28,[37,6],[[28,[37,6],[[30,0,[\"dailyStoriesCounts\"]]],null]],null],null,[[[41,[28,[37,7],[[30,4],0],null],[[[1,\"        \"],[10,0],[14,0,\"cCA--stories__item u--text--white\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[\"stories.scheduled_count.no_stories\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,4],1],null],[[[1,\"        \"],[10,0],[14,0,\"cCA--stories__item\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[\"stories.scheduled_count.one_story\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"cCA--stories__item\"],[12],[1,\"\\n          \"],[1,[28,[35,8],[\"stories.scheduled_count.number_stories\"],[[\"storyCount\"],[[30,4]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]]],[4]],null]],[]],[[[1,\"    \"],[10,0],[14,0,\"cCA--stories__item\"],[12],[1,\"\\n      \"],[1,[28,[35,8],[\"stories.scheduled_count.none_scheduled\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[10,1],[14,0,\"cCA--stories__hint\"],[12],[1,\"\\n    \"],[1,[28,[35,8],[\"stories.scheduled_count.click_stories_tab\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@showAdditionalBanner\",\"@timelineStories\",\"@targetDate\",\"dayStoryCount\"],false,[\"concat-classes\",\"if\",\"did-insert\",\"did-update\",\"on\",\"each\",\"-track-array\",\"are-equal\",\"t\"]]",
    "moduleName": "calendar/components/calendar/scheduled-stories.hbs",
    "isStrictMode": false
  });
  let ScheduledStoriesComponent = _exports.default = (_dec = (0, _service.inject)('calendar/config'), _dec2 = (0, _computed.readOnly)('calendarConfig.fullCalendar'), _dec3 = (0, _computed.readOnly)('userConfig.currentTimeZone.identifier'), (_class = class ScheduledStoriesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "router", _descriptor2, this);
      _initializerDefineProperty(this, "calendarConfig", _descriptor3, this);
      _initializerDefineProperty(this, "userConfig", _descriptor4, this);
      _initializerDefineProperty(this, "dailyStoriesCounts", _descriptor5, this);
      _initializerDefineProperty(this, "fullCalendar", _descriptor6, this);
      _initializerDefineProperty(this, "timeZoneIdentifier", _descriptor7, this);
    }
    get currentTimeZoneIdentifier() {
      return (0, _utils.isEmpty)(this.timeZoneIdentifier) ? _moment.default.tz.guess() : this.timeZoneIdentifier;
    }
    get showFutureTrendsOnCalendar() {
      return this.auth.currentAccount?.rolloutFutureInsightsOnCalendar;
    }
    async fetchStoryCounts() {
      if (this.fullCalendar) {
        const dailyStoriesCounts = [];
        const startTime = (0, _moment.default)(this.fullCalendar?.view.activeStart);

        // For each day of the week
        for (let i = 0; i < 7; i++) {
          const unixStartTime = startTime.unix();
          const unixEndTime = unixStartTime + _timeFormat.convert.day().toSeconds();
          const dayStoryCount = this.args.timelineStories.filter(story => {
            const storyUnixStartTime = story.startTime ? (0, _moment.default)(story.startTime).unix() : (0, _moment.default)().unix();
            return storyUnixStartTime >= unixStartTime && storyUnixStartTime < unixEndTime;
          }).length;
          dailyStoriesCounts.push(dayStoryCount);
          startTime.add(1, 'day');
        }
        if (dailyStoriesCounts.every(count => count === 0)) {
          this.dailyStoriesCounts = [];
        } else {
          this.dailyStoriesCounts = dailyStoriesCounts;
        }
      }
    }
    viewStoriesCalendar() {
      this.router.transitionTo('cluster.schedule.stories');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dailyStoriesCounts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "fullCalendar", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "timeZoneIdentifier", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "fetchStoryCounts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "fetchStoryCounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewStoriesCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "viewStoriesCalendar"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ScheduledStoriesComponent);
});